export default "__VITE_ASSET__dDcW57cP__"